import { Component, Input, OnInit } from "@angular/core";
import { PlayerInjuryDto } from "app/models";

@Component({
    selector: 'next-fixture-injury',
    templateUrl: './next-fixture-injury.component.html',
    styleUrls: ['./next-fixture-injury.component.scss'],
})
export class NextFixtureInjury implements OnInit {
    @Input() homeInjuries: PlayerInjuryDto[];

    @Input() visitorInjuries: PlayerInjuryDto[];
    
    ngOnInit(): void {
        
    }

    getFirstName(name: string) {
        if (!name) return null;

        return name[0] + ".";
    }
}